export const formatDate = (date) => {
  const formatObj = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  return new Date(date).toLocaleString('en-GB', formatObj);
};

export const dateFromUnixTimestamp = (timestamp) => (timestamp ? formatDate(timestamp * 1000) : '');

export const formatUnix = (unixTimeStamp) => (unixTimeStamp ? new Date(unixTimeStamp * 1000) : null);

export const dateStringToSeconds = (dateString) => (new Date(dateString).getTime() / 1000).toFixed(0);
